var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOurSerives4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.227 27.72L33.2307 15.4658L42.7428 27.3879L43.2708 28.0513L34.227 27.72ZM17.8 50.5934H42.4277V32.6081H17.8V50.5934ZM47.9119 28.0513L47.8012 27.915L47.7757 27.8903L33.0263 10.0156L32.6175 9.52172C32.328 9.26625 31.9448 9.12148 31.5275 9.12148H26.418V7.87817H18.4728V9.12148H14.2149C13.2781 9.12148 12.5117 9.87939 12.5117 10.8246V54.3906C12.5117 55.3367 13.2781 56.0938 14.2149 56.0938H46.5749C47.5117 56.0938 48.2781 55.3367 48.2781 54.3906V29.091C48.2781 28.6899 48.1418 28.3323 47.9119 28.0513Z",
    fill: "#E53133"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.0267 10.0148L32.6179 9.52087C32.7891 9.65627 32.9253 9.82744 33.0267 10.0148Z",
    fill: "#E53133"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7998 7.02412H27.0965V3.36914H17.7998V7.02412Z",
    fill: "#E53133"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.5599 46.6933C29.2703 47.085 28.6998 46.7359 28.3591 46.5485C27.9504 46.3271 27.1584 45.6799 27.2265 45.1179C27.3458 44.3259 28.1377 44.8624 28.5891 45.2363C29.1852 45.7821 29.6876 46.5315 29.5599 46.6933ZM33.9285 41.5319L33.8604 41.4305L30.4029 35.2566L26.7411 41.7627C26.4005 42.3588 26.2217 43.0486 26.2217 43.7809C26.2217 46.0878 28.0952 47.9451 30.4029 47.9451C32.7107 47.9451 34.5757 46.0878 34.5757 43.7809C34.5757 42.954 34.3372 42.1791 33.9285 41.5319Z",
    fill: "#E53133"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOurSerives4);
export default __webpack_public_path__ + "static/media/ourSerives4.7759a9cf0425beea55648d4e7128bb8c.svg";
export { ForwardRef as ReactComponent };